import React from "react";
import { Form, Input, InputNumber, Select } from "antd";

const DURATION_UNIT_OPTIONS = [
  { value: "сар", label: "сар" },
  { value: "жил", label: "жил" },
];

export default function MainFeaturesSection() {
  return (
    <>
      <Form.Item
        name="coverageObject"
        label="Даатгалын зүйл"
        rules={[{ required: true, message: "Даатгалын зүйл оруулна уу" }]}
      >
        <Input placeholder="Даатгуулагчийн өмчлөд байгаа автомашин" />
      </Form.Item>

      <Form.Item label="Даатгалын хугацаа">
        <div style={{ display: "flex", gap: 8 }}>
          <Form.Item name="durationValue" noStyle>
            <InputNumber style={{ width: "100%" }} min={1} placeholder="12" />
          </Form.Item>
          <Form.Item name="durationUnit" noStyle initialValue="сар">
            <Select style={{ width: 100 }} options={DURATION_UNIT_OPTIONS} />
          </Form.Item>
        </div>
      </Form.Item>

      <Form.Item name="premiumRate" label="Хураамжийн хувь">
        <Input placeholder="Автомашины үнээс шалтгаална эсвэл 2.5%" />
      </Form.Item>
    </>
  );
}
